import { UIText2 } from '@cian/ui-kit';
import { IconActionArrowUpRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

interface IAuthorLinkProps {
  url: string;
  text: string;
  onClick(): void;
}

export function AuthorLink({ url, text, onClick }: IAuthorLinkProps) {
  const [hovered, setHovered] = React.useState(false);

  const changeHovered = React.useCallback(() => setHovered(!hovered), [hovered]);

  return (
    <a
      data-testid="author-link"
      className={styles['link']}
      href={url}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
      onMouseOver={changeHovered}
      onMouseOut={changeHovered}
    >
      <UIText2 color="text-main-default">{text}</UIText2>

      <div className={styles['arrow']}>
        <IconActionArrowUpRight16 color="icon-main-default" />
      </div>
    </a>
  );
}
